
import React from "react";
import amazon from "../../assets/Artboard 4.png";
import tanishq from "../../assets/Artboard 2.png";
import myntra from "../../assets/Artboard 4.png";
import hp from "../../assets/Artboard 5.png";
import zomato from "../../assets/Artboard 6.png";
import bookymyshow from "../../assets/Artboard 7.png";
import Uber from "../../assets/Artboard 8.png";
import decathlon from "../../assets/Artboard 9.png";
import croma from "../../assets/Artboard 11.png";
import disney from "../../assets/Artboard 12.png";
import pepperfry from "../../assets/Artboard 13.png"
import cultpass from "../../assets/Artboard 14.png"
import phonepay from "../../assets/Artboard 15.png"
import nike from "../../assets/Artboard 16.png"
import ganna from "../../assets/Artboard 17.png"
import homeCenter from "../../assets/Artboard 18.png"
import bigbasket from "../../assets/Artboard 19.png"
import bodycraft from "../../assets/bodycraft.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  const imageUrls = [
    amazon, tanishq, myntra, hp, zomato, bookymyshow, Uber,
    decathlon, croma, disney, pepperfry, cultpass, phonepay,
    nike, ganna, homeCenter, bigbasket, bodycraft
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between px-2">
        <h3 className="text-base font-semibold text-gray-800">Premium Reward Partners</h3>
        <div className="flex gap-1">
          <div className="h-1 w-4 bg-[#004f6b] rounded-full"></div>
          <div className="h-1 w-1 bg-gray-200 rounded-full"></div>
        </div>
      </div>

      <div className="px-2">
        <Slider {...settings} className="voucher-slider">
          {imageUrls.map((image, index) => (
            <div key={index} className="px-3 outline-none">
              <div className="bg-white p-2 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group overflow-hidden">
                <img
                  src={image}
                  alt={`Partner ${index + 1}`}
                  className="w-full h-auto object-contain filter transition-all duration-500 transform group-hover:scale-110"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <style jsx>{`
        .voucher-slider :global(.slick-list) {
          overflow: visible;
        }
        .voucher-slider :global(.slick-track) {
          display: flex;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export default Carousel;
